import { requestWithMethod } from "../helpers/request";

const BASE = "/template-message";

// Categories
export function getCategories() {
  return requestWithMethod(`${BASE}/category`, { method: "GET" });
}

export function createCategory(name) {
  return requestWithMethod(`${BASE}/category`, {
    method: "POST",
    data: { name }
  });
}

export function updateCategory(id, name) {
  return requestWithMethod(`${BASE}/category/${id}`, {
    method: "PATCH",
    data: { name }
  });
}

export function deleteCategory(id) {
  return requestWithMethod(`${BASE}/category/${id}`, { method: "DELETE" });
}

// Templates
export function getTemplates() {
  return requestWithMethod(BASE, { method: "GET" });
}

export function createTemplate(data) {
  return requestWithMethod(BASE, { method: "POST", data });
}

export function updateTemplate(id, data) {
  return requestWithMethod(`${BASE}/${id}`, { method: "PATCH", data });
}

export function deleteTemplate(id) {
  return requestWithMethod(`${BASE}/${id}`, { method: "DELETE" });
}

// Variables
export function getVariables() {
  return requestWithMethod(`${BASE}/variables`, { method: "GET" });
}

// Render
export function renderTemplate(templateMessageId, leadId) {
  return requestWithMethod(`${BASE}/render`, {
    method: "POST",
    data: { templateMessageId, leadId }
  });
}
